<template>
    <svg :class="['svg--'+name]">
        <use :xlink:href="static('svg/'+BUNDLE+'/symbol/svg/sprite.symbol.svg#'+name)"></use>
    </svg>
</template>

<script>
export default {
    name: "SvgView",
    props: {
        name: String
    },
    computed: {
        BUNDLE: () => BUNDLE
    }
};
</script>